import { withInstall } from '@sgui-plus/utils/with-install'
import Tooltip from './src/tooltip.vue'

export const SgTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/trigger'
export * from './src/content'
export * from './src/constants'
export default SgTooltip
